<script>
	import { onMount } from 'svelte'
	import { fade, fly } from 'svelte/transition'

	const { $: jQuery } = window

	let shown = false
	let service = false

	let html

	const closePopup = () => {
		html.classList.remove('show-modal')
		shown = false
	}

	const wrapClick = e => e.target === e.currentTarget && closePopup()

	onMount(() => {
		html = document.getElementsByTagName('html')[0]
		jQuery(document).on('click', '.service-item', e => {
			e.preventDefault()
			html.classList.add('show-modal')
			service = jQuery(e.currentTarget).data('service')
			shown = true
		})
		jQuery(document).on('click', '.service-container > .content > .btn', e => {
			e.preventDefault()
			let $serviceContainer = document.querySelector('.service-container')
			html.classList.add('show-modal')
			service = jQuery(e.currentTarget)
				.closest('.service-container')
				.data('service')
			shown = true
		})
	})
</script>

<style type="text/scss">
	.main {
		align-self: center;
		width: unset;
		height: 100%;
		margin: auto;
	}
</style>

<svelte:window on:keyup={e => e.keyCode === 27 && closePopup()} />

{#if shown && service}
	<div
		class="team-popup-wrap"
		on:click={wrapClick}
		transition:fade={{ duration: 300 }}>
		<div class="main" on:click={wrapClick}>
			<div class="inner-wrap" in:fly={{ y: 15 }} out:fly={{ y: -15 }}>
				<div class="team-popup">
					<div class="popup-inner popup-content">
						{@html service.content}
					</div>
				</div>
				<button class="close-popup" on:click={closePopup}>
					<span>&times;</span>
				</button>
			</div>
		</div>
	</div>
{/if}
